import compose from 'recompose/compose';
import when from 'recompose/branch';
import withProps from 'recompose/withProps';
import mapProps from 'recompose/mapProps';
import { connect } from 'react-redux';

import noop from 'lodash/noop';

import withGlobalContent from './withGlobalContent';
import { addFlashMessageError, addFlashMessageNotice } from '../components/FlashMessages/duck';

const withErrorTranslations = compose(
  when(props => props.globalContent,
    // If globalContent exists in props then keep it and also add errors
    withProps(({ globalContent }) => ({
      errors: globalContent.error
    })),
    // If globalContent doesnt exist in props then add it but only keep errors prop
    compose(
      withGlobalContent,
      mapProps(({ globalContent, ...props }) => ({
        ...props,
        errors: globalContent.error
      })),
    )
  ),
  connect(
    null,
    (dispatch, { errors }) => ({
      sendErrorMessage: (fn = noop) => {
        const message = fn(errors) || errors.general.default;
        return dispatch(addFlashMessageError(message));
      },
      sendWarningMessage: fn => {
        const message = fn(errors);
        return message && dispatch(addFlashMessageNotice(message));
      }
    })
  )
);

export default withErrorTranslations;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/withErrorTranslations.js